import React from 'react';
import './Input.css';

const Input = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder = '',
  size = 'md', // sm, md, lg
  required = false,
  disabled = false,
  id, 
  className = '',
  inputStyle = {},
  labelStyle = {},
 }) => {
  const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`;

  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "input-sm";
      case "lg":
        return "input-lg";
      default:
        return "input-md";
    }
  };

  return (
    <div className={`input-container ${className}`}>
      {label && <label htmlFor={inputId} style={{ ...labelStyle }}>{label}</label>}
      <input
        id={inputId}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`input-style ${getSizeClass()}`}
        style={{ ...inputStyle }}
      />
    </div>
  );
};

export default Input;
